// extracted by mini-css-extract-plugin
export var smallTitle = "two-col-image-promo-module--smallTitle--ixxdg";
export var staggeredColumnHeight = "two-col-image-promo-module--staggeredColumnHeight--vFNcb";
export var text = "two-col-image-promo-module--text--cSkZS";
export var twoColImagePromo = "two-col-image-promo-module--twoColImagePromo--UkO8i";